import { ApolloClient } from '@apollo/client/core';
import { HttpLink } from '@apollo/client';
import { InMemoryCache } from '@apollo/client/cache';
import { setContext } from '@apollo/client/link/context';
import 'whatwg-fetch'; // Polyfill for IE

import { getCookieValue } from '../cookies';

const authLink = setContext((_, { headers }) => {
  const token = getCookieValue('token');

  return {
    headers: {
      ...headers,
      Authorization: token !== '' ? `Bearer ${token}` : null,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(new HttpLink({ uri: window.GRAPHQL_URL })),
  cache: new InMemoryCache(),
});

export default client;
